import { supabase } from './supabase';
import { sendEmail, generatePasswordResetEmail } from './email';

export async function signIn(email: string, password: string) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password
  });

  if (error) {
    throw error;
  }

  // Verify user is an admin
  const { data: admin, error: adminError } = await supabase
    .from('admins')
    .select('id')
    .eq('email', email)
    .single();

  if (adminError || !admin) {
    await supabase.auth.signOut();
    throw new Error('Unauthorized access');
  }

  return data;
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  if (error) {
    throw error;
  }
}

export async function getSession() {
  const { data: { session }, error } = await supabase.auth.getSession();
  if (error) {
    throw error;
  }
  return session;
}

export async function isAdmin() {
  const session = await getSession();
  if (!session) return false;

  const { data: admin, error } = await supabase
    .from('admins')
    .select('id')
    .eq('email', session.user.email)
    .single();

  return !error && admin;
}

export async function resetPassword(email: string) {
  try {
    // First verify this is an admin email
    const { data: admin, error: adminError } = await supabase
      .from('admins')
      .select('id')
      .eq('email', email)
      .single();

    if (adminError || !admin) {
      throw new Error('Unauthorized email address');
    }

    // Generate reset token and URL
    const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password-confirm`,
    });

    if (error) throw error;

    // Send custom password reset email
    await sendEmail({
      to: email,
      subject: 'Reset Your PropViper Password',
      html: generatePasswordResetEmail(`${window.location.origin}/reset-password-confirm`),
      type: 'password-reset'
    });

    return { success: true };
  } catch (error) {
    console.error('Password reset error:', error);
    throw error;
  }
}